/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useRef } from 'react';
import { track } from '../../external_dependencies/analytic/index';
import { InstallmentsStyles } from './InstallmentsWithoutInterest.style';

const InstallmentsWithoutInterest = ({ product, userSegments, isUserLoggedIn, appCtx }) => {
  const isTrackedRef = useRef(false);
  const { installmentsWithoutInterest = [] } = product;
  const segments = useMemo(() => userSegments, [userSegments]);
  const isLoggedIn = useMemo(() => isUserLoggedIn, [isUserLoggedIn]);
  const isInstallmentsEnabledForKiosk = appCtx?.siteConfig?.toggles.isInstallmentsEnabledForKiosk ?? false;

  useEffect(() => {
    if (isLoggedIn && window && window?.digitalData) {
      const userSegmentNames = segments?.map((segmentItem) => segmentItem?.name)?.join('|');
      window.digitalData.usersegment = userSegmentNames || null;
    }
  }, [segments, isLoggedIn]);

  if (!installmentsWithoutInterest.length || (appCtx?.isKiosk && !isInstallmentsEnabledForKiosk)) {
    return null;
  }

  let maxInstallments = 0;

  if (isUserLoggedIn) {
    const userSegmentNames = segments?.map((segmentItem) => segmentItem.name);
    let isMatch = false;
    const filteredInstallmentsWithoutInterest = installmentsWithoutInterest.filter((itemWithoutInterest) => {
      if (!itemWithoutInterest?.userSegment?.length) {
        return itemWithoutInterest;
      }
      const isInstallmentsWithoutInterestInUserSegment = itemWithoutInterest.userSegment.some((itemUserSegment) =>
        userSegmentNames.includes(itemUserSegment)
      );
      isMatch = isMatch || isInstallmentsWithoutInterestInUserSegment;
      return isInstallmentsWithoutInterestInUserSegment && itemWithoutInterest;
    });
    const uniqueInstallments = [
      ...new Set(filteredInstallmentsWithoutInterest.map((item) => Number(item.installments))),
    ];

    maxInstallments = uniqueInstallments.length > 0 ? Math.max(...uniqueInstallments) : 0;

    if (
      maxInstallments > 0 &&
      isMatch &&
      !isTrackedRef.current &&
      typeof window !== 'undefined' &&
      window &&
      window._satellite
    ) {
      track('segmentedcsi');
      isTrackedRef.current = true;
    }
  } else {
    const itemWithHighestinstallment = installmentsWithoutInterest?.reduce((max, current) =>
      current.installments > max.installments ? current : max
    );

    if (itemWithHighestinstallment && !itemWithHighestinstallment?.userSegment?.length) {
      maxInstallments = itemWithHighestinstallment.installments;
    } else {
      return null;
    }
  }

  return maxInstallments > 0 ? (
    <>
      <div className="installments-text">
        <span className="cmr-icon" />
        <span>{maxInstallments} cuotas sin interés</span>
      </div>
      <style jsx>{InstallmentsStyles}</style>
    </>
  ) : null;
};

InstallmentsWithoutInterest.propTypes = {
  product: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
  userSegments: PropTypes.array.isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
};

export default InstallmentsWithoutInterest;
